(function () {
  'use strict';

  /* =========================
     DOLJ GAMLA HJARTKNAPPAR PA PRODUKTKORT
     Hjartat pa produktsidan (.lux-wishlist-btn bredvid "Lagg i varukorgen")
     visas. Pa produktkort anvands hjartat fran meny.liquid i stallet.
     ========================= */

  (function hideCardHearts() {
    if (document.getElementById('ff-hide-hearts')) return;
    const style = document.createElement('style');
    style.id = 'ff-hide-hearts';
    style.textContent = '.ff-wishlist-button:not(.lux-wishlist-btn) { display: none !important; }';
    (document.head || document.documentElement).appendChild(style);
  })();

  const STORAGE_KEY = 'finafransar_favorites';

  function handleFromUrl(url) {
    const match = String(url || '').match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function normalizeUrl(url) {
    const handle = handleFromUrl(url);
    return handle ? '/products/' + handle : url;
  }

  function getFavorites() {
    try {
      const list = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
      if (!Array.isArray(list)) return [];
      /* Laga aldre sparade favoriter som saknar handle */
      let changed = false;
      list.forEach(function (item) {
        if (item && !item.handle && item.url) {
          item.handle = handleFromUrl(item.url);
          changed = true;
        }
      });
      if (changed) {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
      }
      return list;
    } catch (error) {
      return [];
    }
  }

  function saveFavorites(favorites) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(favorites));
    } catch (error) {}
    updateFavoriteButtons();
    updateFavoriteCount();

    if (window.location.pathname === '/pages/favoriter') {
      renderFavoritesPage();
    }
  }

  function findIndex(favorites, url) {
    const handle = handleFromUrl(url);
    return favorites.findIndex(function (item) {
      return (handle && item.handle === handle) || item.url === url;
    });
  }

  function isFavorite(url) {
    return findIndex(getFavorites(), url) !== -1;
  }

  function updateFavoriteButtons() {
    document
      .querySelectorAll('.ff-wishlist-button')
      .forEach(function (button) {
        const url = button.dataset.productUrl;
        if (!url) return;
        if (isFavorite(url)) {
          button.classList.add('ff-favorited');
          button.setAttribute('aria-pressed', 'true');
          button.setAttribute('aria-label', 'Ta bort från favoriter');
        } else {
          button.classList.remove('ff-favorited');
          button.setAttribute('aria-pressed', 'false');
          button.setAttribute('aria-label', 'Lägg till i favoriter');
        }
      });
  }

  function updateFavoriteCount() {
    const count = getFavorites().length;
    document
      .querySelectorAll('.ff-favorite-count')
      .forEach(function (element) {
        element.textContent = count;
        element.style.display = count > 0 ? 'inline-flex' : 'none';
      });
  }

  /* Hamtar pris m.m. sa att onskelistan visar ratt pris */
  function enrichFavorite(handle) {
    if (!handle) return;
    fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (product) {
        if (!product) return;
        const favorites = getFavorites();
        const item = favorites.find(function (fav) { return fav.handle === handle; });
        if (!item) return;
        item.price = product.price;
        item.available = product.available;
        if (!item.image && product.featured_image) item.image = product.featured_image;
        if (!item.title) item.title = product.title;
        try {
          localStorage.setItem(STORAGE_KEY, JSON.stringify(favorites));
        } catch (error) {}
      })
      .catch(function () {});
  }

  function setupFavoriteButtons() {
    document
      .querySelectorAll('.ff-wishlist-button')
      .forEach(function (button) {
        if (button.dataset.favoriteReady === 'true') return;
        button.dataset.favoriteReady = 'true';

        button.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();

          const rawUrl = button.dataset.productUrl;
          if (!rawUrl) return;
          const url = normalizeUrl(rawUrl);
          const handle = handleFromUrl(rawUrl);
          const title = button.dataset.productTitle || 'Produkt';
          const image = button.dataset.productImage || '';

          const favorites = getFavorites();
          const existingIndex = findIndex(favorites, rawUrl);

          if (existingIndex !== -1) {
            favorites.splice(existingIndex, 1);
            saveFavorites(favorites);
          } else {
            favorites.push({
              handle: handle,
              url: url,
              title: title,
              image: image,
              price: null,
              available: true
            });
            saveFavorites(favorites);
            enrichFavorite(handle);
          }
        });
      });

    updateFavoriteButtons();
  }

  function renderFavoritesPage() {
    if (window.location.pathname !== '/pages/favoriter') return;

    let page = document.querySelector('.ff-favorites-page');
    if (!page) {
      page = document.createElement('div');
      page.className = 'ff-favorites-page';
      const main = document.querySelector('main');
      if (main) {
        main.prepend(page);
      } else {
        document.body.appendChild(page);
      }
    }

    const favorites = getFavorites();
    page.innerHTML = '';

    const inner = document.createElement('div');
    inner.className = 'ff-favorites-inner';

    const heading = document.createElement('h1');
    heading.textContent = 'Mina favoriter';
    inner.appendChild(heading);

    if (favorites.length === 0) {
      const empty = document.createElement('div');
      empty.className = 'ff-favorites-empty';
      empty.innerHTML = '<p>Du har inga favoriter ännu.</p><a href="/collections/all">Utforska produkter</a>';
      inner.appendChild(empty);
    } else {
      const grid = document.createElement('div');
      grid.className = 'ff-favorites-grid';

      favorites.forEach(function (product) {
        const item = document.createElement('div');
        item.className = 'ff-favorite-product';

        const link = document.createElement('a');
        link.href = product.url;

        if (product.image) {
          const image = document.createElement('img');
          image.src = product.image;
          image.alt = product.title;
          image.loading = 'lazy';
          link.appendChild(image);
        }

        const title = document.createElement('h2');
        title.textContent = product.title;
        link.appendChild(title);
        item.appendChild(link);

        const remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'ff-remove-favorite';
        remove.textContent = '♥ Ta bort';
        remove.addEventListener('click', function () {
          const updatedFavorites = getFavorites().filter(function (favorite) {
            return favorite.handle !== product.handle && favorite.url !== product.url;
          });
          saveFavorites(updatedFavorites);
        });

        item.appendChild(remove);
        grid.appendChild(item);
      });

      inner.appendChild(grid);
    }

    page.appendChild(inner);
  }

  function init() {
    setupFavoriteButtons();
    updateFavoriteCount();
    renderFavoritesPage();

    /* Fyll i pris for gamla favoriter som saknar det */
    getFavorites().forEach(function (item) {
      if (item.handle && (item.price === null || item.price === undefined)) {
        enrichFavorite(item.handle);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', function () {
    setTimeout(init, 100);
  });

  setTimeout(init, 500);
  setTimeout(init, 1500);

})();
